export const MINIMUM_RULER_DURATION = 188; // ms
